import { initialAdminDefinitionsState } from 'app/core/store/admin/admin-definitions/admin-definitions.model';
import { AdminState } from 'app/core/store/admin/admin.interface';
import { initialClientUsers, initialEditUser, initialEpsUsers, initialSyncWithAD } from 'app/core/store/admin/users/users.model';

export const ADMIN_INITIAL_STATE: AdminState = {
  adminDefinitions: initialAdminDefinitionsState,
  clientUsers: initialClientUsers,
  edit: initialEditUser,
  epsUsers: initialEpsUsers,
  sync: initialSyncWithAD,
};
